<template>
  <div>
	  <div class="footer">
	  	<div class="foot-top">
	  		<div class="foot-img"></div>
	  		<div class="container">
	  			<div class="visual">
	  				<div class="footer-left">
	  					<div class="tel marginR14">
	  						<ul class="phoneBox">
	  							<li>
	  								<span class="contact">联系我们</span>
	  								<p style="font-size: 14px;font-weight: normal;" ng-if="!basicSetting">
                      400 866 0006</p>
	  							</li>
	  							<li>
	  								<span class="contact">工作时间</span>
	  								<span class="websitNumber">8：00 -17：00</span>
	  							</li>
	  						</ul>
	  					</div>
	  				</div>
	  				<div class="footer-right">
	  					<div class="bt-nav">
	  						<a href="javascript:void(0);" class="first-a">购物指南</a>
	  						<ul class="trade-ul common-ul">
	  							<li>
	  								<a href="javascript:void(0);">注册流程</a>
	  							</li>
	  							<li>
	  								<a href="javascript:void(0);">订单流程</a>
	  							</li>
	  						</ul>
	  					</div>
	  					<div class="bt-nav">
	  						<a href="javascript:void(0);" class="first-a">积分兑换</a>
	  						<ul class="trade-ul common-ul">
	  						</ul>
	  					</div>
	  					<div class="bt-nav">
	  						<a href="javascript:void(0);" class="first-a">配送方式</a>
	  						<ul class="trade-ul common-ul">
	  						</ul>
	  					</div>
	  					<div class="bt-nav">
	  						<a href="javascript:void(0);" class="first-a">常见问题</a>
	  						<ul class="trade-ul common-ul">	  							
	  						</ul>
	  					</div>
						<div class="bt-nav">
	  						<a href="javascript:void(0);" class="first-a"></a>
	  						<ul class="trade-ul common-ul">	  							
	  						</ul>
	  					</div>
						<div class="bt-nav">
	  						<a href="javascript:void(0);" class="first-a"></a>
	  						<ul class="trade-ul common-ul">	  							
	  						</ul>
	  					</div>
						<div class="bt-nav">
							<a href="javascript:void(0);" class="first-a"><img src="/img/logo-tz-cn.png" alt="" srcset="" width="100"></a>
	  						<a href="javascript:void(0);" class="first-a"><img src="/img/logo-tz-en.png" alt="" srcset="" width="100"></a>
	  						<ul class="trade-ul common-ul">				
	  						</ul>
	  					</div>
	  				</div>
	  			</div>
	  		</div>
	  	</div>
	  	<div class="container">
        <div class="footer-bottom-box">
          <div class="copyright fcc">
            <a target="_blank" href="https://beian.miit.gov.cn/"
               style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
              <p style="display: inline-block;">&nbsp;&nbsp;&nbsp;&nbsp;© Copyright ©2017 浙江天正电气股份有限公司 All Rights Reserved ⋅ 浙ICP备05055822号-4</p>
            </a>
          </div>
        </div>
	  	</div>
	  </div>
  </div>
</template>

<script>
const DINGTALK_KEFU_APP_CODE =
  process.env.VUE_APP_DINGTALK_KEFU_APP_CODE || 'b485c718fbce47ec833f08aa0c4e1d22'
const DINGTALK_KEFU_BUBBLE_SRC =
  process.env.VUE_APP_DINGTALK_KEFU_BUBBLE_URL ||
  'https://o.alicdn.com/dingding/smart-customer-bubble/index.js'

function getVisitorId() {
  let visitorId = localStorage.getItem('visitor_unique_id')
  if (!visitorId) {
    visitorId = 'visitor_' + Math.random().toString(36).substring(2, 15)
    localStorage.setItem('visitor_unique_id', visitorId)
  }
  return visitorId
}

function getKefuUser() {
  let userId = getVisitorId()
  let userName = '访客用户'
  try {
    const raw = sessionStorage.getItem('userInfo')
    if (raw && raw !== '{}') {
      const userInfo = JSON.parse(raw)
      if (userInfo.name) {
        userName = userInfo.name
      }
      if (userInfo.uid != null) {
        userId = String(userInfo.uid)
      } else if (userInfo.id != null) {
        userId = String(userInfo.id)
      }
    }
  } catch (e) { /* ignore */ }
  return {
    id: userId,
    name: userName,
    avatar: '',
    email: ''
  }
}

function injectDingtalkAiCustomer() {
  if (document.querySelector('script[data-dingtalk-ai-customer]')) {
    return
  }
  window.aiCustomerAgentConfig = {
    appCode: DINGTALK_KEFU_APP_CODE,
    user: getKefuUser(),
    company: {
      id: 'default_company',
      name: '天正官网'
    },
    extension: {
      appVersion: 'web_guest'
    }
  }
  const script = document.createElement('script')
  script.src = DINGTALK_KEFU_BUBBLE_SRC
  script.async = true
  script.setAttribute('data-dingtalk-ai-customer', '')
  document.body.appendChild(script)
}

export default {
  name: 'i-footer',
  data() {
    return {}
  },
  mounted() {
    injectDingtalkAiCustomer()
  },
  methods: {}
}
</script>

<style scoped="scoped" lang="less">

</style>
